import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { getWishlisted } from '../modules/button/utils/get-wishlisted.js';
import { getWishlistSkus } from '../utils/get-wishlist-skus.js';
import { useGetWishlist } from './use-get-wishlist.js';
import { useWishlistActions } from './use-wishlist-actions.js';

/**
 * This hook is only used to integrate our wishlist system with the VTO of VirtualMirror.
 */ const useVtoWishlist = ()=>{
    const { data , error , loading  } = useGetWishlist();
    const { addToShoppinglist , removeFromShoppinglist  } = useWishlistActions('pdp');
    const wishlistedSkuItems = React.useMemo(()=>{
        return getWishlistSkus(data === null || data === void 0 ? void 0 : data.items);
    }, [
        data === null || data === void 0 ? void 0 : data.items
    ]);
    const onToggleWishlist = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(sku) {
            if (error || loading || !sku) {
                return Promise.reject();
            }
            const isWishlisted = getWishlisted(sku, data === null || data === void 0 ? void 0 : data.items);
            const action = isWishlisted ? 'remove' : 'add';
            if (action === 'add') {
                const response = yield addToShoppinglist([
                    sku
                ], data === null || data === void 0 ? void 0 : data.id);
                if (response.addToShoppinglist.__typename === 'AddToShoppinglistSuccessResponse') {
                    return Promise.resolve();
                }
            } else {
                const response = yield removeFromShoppinglist([
                    sku
                ], data === null || data === void 0 ? void 0 : data.id);
                if (response.removeFromShoppinglist.__typename === 'RemoveFromShoppinglistSuccessResponse') {
                    return Promise.resolve();
                }
            }
            return Promise.reject();
        });
        return function(sku) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addToShoppinglist,
        data,
        error,
        loading,
        removeFromShoppinglist
    ]);
    return {
        onToggleWishlist,
        wishlistedSkuItems
    };
};

export { useVtoWishlist };
//# sourceMappingURL=use-vto-wishlist.js.map
